import { SET_COLLECTION_CHOICE_ENDPOINT } from '@/constants/endpoints'
import { DEFAULT_ERROR_MESSAGE } from '~/constants/errorMessage'

export default {
  methods: {
    async sendCollectionChoiceMethodData ({ collectionChoice, zipCode, userEmail, city = null, stateCode = null, shippingAddress = null, name = null, phone = null }) {
      const userId = sessionStorage.getItem('ud')

      const data = {
        choice: collectionChoice,
        email: userEmail,
        zipcode: zipCode,
        formattedShippingAddress: shippingAddress,
        userID: userId,
        name,
        phone,
        city,
        stateCode
      }
      try {
        return await this.$axios.$post(SET_COLLECTION_CHOICE_ENDPOINT, data)
      } catch (e) {
        const { response: { status, data: { code = '' } = {} } } = e
        const isInvalidAddress = status === 400 && code === 'INVALID_ADDRESS'
        const errorMessage = isInvalidAddress
          ? 'There is a problem with you address, please type it again. If the problem persist contact us at members@get-base.com'
          : DEFAULT_ERROR_MESSAGE
        throw new Error(errorMessage)
      }
    }
  }
}
